import { MutationHookOptions, useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { LogoutMutationMutation, LogoutMutationMutationVariables } from '__generated__/graphql';
import { useDefaultOnError } from './useDefaultOnError';

const LOGOUT_MUTATION = gql(/* GraphQL */ `
  mutation logoutMutation {
    logout(input: {}) {
      clientMutationId
    }
  }
`);

export function useLogoutUser(options?: MutationHookOptions<LogoutMutationMutation, LogoutMutationMutationVariables>) {
  const onError = useDefaultOnError();

  return useMutation(LOGOUT_MUTATION, {
    onError: (err) => onError(err),
    ...options,
  });
}
